import { createColor } from '../components/colorPicker/colorPicker.helpers';

export const RANGE_DEFAULT_LOW_VALUE_COLOR = createColor('#29FD2E');
export const RANGE_DEFAULT_MEDIUM_VALUE_COLOR = createColor('#FFFD38');
export const RANGE_DEFAULT_HIGH_VALUE_COLOR = createColor('#FC101B');
